module.exports = __webpack_public_path__ + "static/media/liderazgo.fcf5725d.jpg";